<template>
  <div>
  <div v-if="$auth.policies['food-menu-list']">
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs
        headline="Quản lý suất ăn"
        :link="[
          {
            text: 'Quản lý suất ăn',
            href: '../food-menu'
          }
        ]"
      />
    </div>

    <v-card outlined class="pa-3 pa-sm-6 mx-4 mb-6 elevation-0">
      <!-- Desktop: 1 hàng -->
      <div class="d-none d-sm-flex align-center justify-space-between">
        <v-btn dark outlined class="search-button" @click="backWeek">
          Tuần trước
        </v-btn>
        <div>
          Tuần từ:
          <span class="text-h6 font-weight-bold">{{ startWeek | ddmm }}</span>
          đến
          <span class="text-h6 font-weight-bold">{{ endWeek | ddmm }}</span>
        </div>
        <v-btn dark outlined class="search-button" @click="nextWeek">
          Tuần sau
        </v-btn>
      </div>
      <!-- Mobile: ngày ở trên, 2 nút bằng nhau ở dưới -->
      <div class="d-sm-none">
        <div class="text-center mb-3">
          Tuần từ
          <div>
            <span class="text-h6 font-weight-bold">{{ startWeek | ddmm }}</span>
            <span class="mx-1">đến</span>
            <span class="text-h6 font-weight-bold">{{ endWeek | ddmm }}</span>
          </div>
        </div>
        <div class="d-flex" style="gap: 12px">
          <v-btn dark outlined small class="flex-grow-1 search-button" @click="backWeek">Tuần trước</v-btn>
          <v-btn dark outlined small class="flex-grow-1 search-button" @click="nextWeek">Tuần sau</v-btn>
        </div>
      </div>
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <FoodMenuDataTable ref="table" />
    </v-card>
  </div>
  <div v-else></div>
</div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import FoodMenuDataTable from '@/modules/foodMenu/FoodMenuDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    FoodMenuDataTable
  },
  props: {},
  data() {
    return {
      time: moment().toISOString()
    }
  },
  computed: {
    ...mapGetters('FoodMenu', ['startWeek', 'endWeek', 'date'])
  },
  methods: {
    ...mapActions('FoodMenu', ['setDate']),
    async refresh(query) {
      this.$refs.table.refresh(query)
    },
    onFilterChange() {
      this.setDate(this.time)
      this.refresh()
    },
    backWeek() {
      this.time = moment(this.time)
        .subtract(7, 'days')
        .toISOString()
      this.setDate(this.time)
      this.refresh()
    },
    nextWeek() {
      this.time = moment(this.time)
        .add(7, 'days')
        .toISOString()
      this.setDate(this.time)
      this.refresh()
    }
  }
}
</script>
<style scoped></style>
